import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Salesforcedevtemplate from "../../component/course/salesforce-developer";


export default class Salesforcedevindelhi extends Component {
 
  render() {
  
    const title = "Salesforce Developer"
    const url= "salesforce-developer"
     const url1 ="-training-in-delhi"
    const location = "delhi" 
    const location1="Training in Delhi"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Learn the skills to become a Salesforce developer in ${location} with our comprehensive training program. Gain hands-on experience working with the Salesforce platform and develop your skills to customize, develop and deploy Salesforce applications.`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Salesforcedevtemplate url1={url1}  title={title} url={url} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
